// extracted by mini-css-extract-plugin
export default {"main":"JoinGame_main__jue6+","description":"JoinGame_description__GzRmJ","logo":"JoinGame_logo__CTdpb"};